import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "./button.js";
import { FractalSDKContext } from "../context/fractal-sdk-context.js";
import { useOnramp } from "../hooks/index.js";
import { useContext } from 'react';
export const BuyCrypto = ({ buttonProps = {}, theme = 'light', onRejected, onFulfillmentComplete, }) => {
    const { user } = useContext(FractalSDKContext);
    const { openOnrampWindow } = useOnramp({
        onFulfillmentComplete,
        onRejected,
        theme,
    });
    if (!user) {
        return null;
    }
    return (_jsx(Button, { ...buttonProps, theme: theme, onClick: openOnrampWindow, children: "Buy Crypto" }));
};
//# sourceMappingURL=buy-crypto.js.map